import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin":"1rem 2rem"} }
const _hoisted_2 = { style: {"padding":"0.5rem 0","line-height":"1.2"} }
const _hoisted_3 = { style: {"display":"inline-block","text-align":"center","width":"100%"} }

import { IonButton, useIonRouter, IonItem } from '@ionic/vue';
import { Storage } from '@ionic/storage';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'TermsAndConditions',
  setup(__props) {

const { t } = useI18n({
      inheritLocale: true,
      useScope: 'global'
})


const router = useIonRouter();
const storage = new Storage();

function push(){
  storage.create().then(() => {
    storage.clear();
    router.push({name: 'sign'});
  });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h3", _hoisted_1, _toDisplayString(_unref(t)('termsConditions.title')), 1),
    _createVNode(_unref(IonItem), { class: "margin-1-rem-tb bradius12" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", null, _toDisplayString(_unref(t)('termsConditions.p1')), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(t)('termsConditions.p2')), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(t)('termsConditions.p3')), 1)
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(IonButton), {
        shape: "round",
        onClick: push
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('termsConditions.accept')), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(IonButton), {
        shape: "round",
        fill: "outline"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('termsConditions.cancel')), 1)
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})